export default __webpack_public_path__ + "static/media/01_Auctioneers-Commercial-EschweilerPhotography_M1A6758.b3a3e07a.jpg";